import axiosInstance from './axios';
import { AxiosResponse } from 'axios';

export const createSatCredential = (
  companyId: number,
  rfc: string,
  password: string
): Promise<{ id: string; status: string }> =>
  axiosInstance
    .post(`/companies/${companyId}/create-sat-credential/`, { rfc, password })
    .then((response: AxiosResponse) => response.data);

export interface ChatHistoryMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

export interface ChatResponse {
  content: string;
  success: boolean;
  error?: string;
}

// MPSA Chat
export const getCompanyMPSAChatResponse = (
  companyId: number,
  query: string,
  language: string = 'en',
  chat_history: ChatHistoryMessage[] = []
): Promise<ChatResponse> => {
  return axiosInstance
    .post(`/companies/${companyId}/documents/mpsa_chat/`, { query, language, chat_history })
    .then((response: AxiosResponse) => response.data);
};

// Admin MPSA Chat
export const adminGetCompanyMPSAChatResponse = (
  companyId: number,
  query: string,
  language: string = 'en',
  chat_history: ChatHistoryMessage[] = []
): Promise<ChatResponse> => {
  return axiosInstance
    .post(`/admins/companies/${companyId}/documents/mpsa_chat/`, { query, language, chat_history })
    .then((response: AxiosResponse) => response.data);
};
